import { createApp } from "vue";
import { createPinia } from "pinia";

// The design baseline stylesheet, copied from the frozen prototype. Imported
// before the app so its tokens and component rules are in place for every page;
// without it each page fell back to a hand-written palette that did not match
// the design.
import "@soulspc/ui/styles/design-baseline.css";
// 用户选定的 SoulSpace 风格层（渐变、玻璃、暖色场景），叠在基准之上。
import "@soulspc/ui/styles/soulspace-theme.css";

import App from "./App.vue";
import { router } from "./router";
import { createAuthGuard } from "./composables/use-auth-guard";
import { setupRouteLoading } from "./composables/use-route-loading";

const app = createApp(App);

app.use(createPinia());
app.use(router);

// Protected routes require a server-confirmed session. Registered here because
// the guard needs the assembled router; without it every page was reachable
// anonymously, including the account pages that can only render an error.
router.beforeEach(createAuthGuard());

// Drives the SoulSpace loading splash: on while a navigation (chunk fetch,
// guard round trip) is in flight, off once it settles.
setupRouteLoading(router);

app.mount("#app");
